export default "__VITE_ASSET__CJpon$zx__"